export const MODALS = {
  UPDATE_CUSTOM_MODEL: 'UPDATE_CUSTOM_MODEL',
  UPDATE_CUSTOM_MODEL_VISIBILITY: 'UPDATE_CUSTOM_MODEL_VISIBILITY',
  POP_UP_TIMEOUT: 2000
};
